export type TraitSelection = {
  base: number;
  eyes: number;
  hair: number;
  hairColor: number;
  outfit: number;
  accessory: number;
  effect: number;
};

export type Rarity = "Unrevealed" | "Common" | "Rare" | "Epic" | "Legendary";

export type ChatMessage = {
  id: string;
  role: "user" | "assistant";
  content: string;
  createdAt: number;
};

export type PersonalityCard = {
  name: string;
  voice: string;
  values: string[];
  likes: string[];
  quirks: string[];
  boundary: string;
  lore: string;
};

export type ProviderConfig = {
  baseUrl: string;
  model: string;
  useProxy: boolean;
};

export type ProviderSecret = {
  apiKey: string;
  config: ProviderConfig;
};

export const DEFAULT_TRAITS: TraitSelection = {
  base: 0,
  eyes: 0,
  hair: 0,
  hairColor: 0,
  outfit: 0,
  accessory: 0,
  effect: 0,
};

export const DEFAULT_PROVIDER: ProviderConfig = {
  baseUrl: "https://openrouter.ai/api/v1",
  model: "openrouter/free",
  useProxy: false,
};

export const PERSONALITY_MAX_BYTES = 512;
